import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PaymentRequestReminderSummaryComponent } from './payment-request-reminder-summary.component';
import { SummaryModule } from '../../../../../../../core/component/summary/summary.module';
import { DatetimeLabelModule } from '../../../../../../../core/component/date/datetime-label/datetime-label.module';
import { WorkflowTaskItemModule } from '../../../../../../../workflow/task/api/component/workflow-task-item/workflow-task-item.module';
import {
    ExpandableContentModule
} from '../../../../../../../core/component/expandable-content/expandable-content.module';
import {LoadingModule} from "../../../../../../../../components/common/loading/loading.module";
import {
    DatetimeSummaryFieldModule
} from "../../../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryModule,
        DatetimeLabelModule,
        ExpandableContentModule,
        WorkflowTaskItemModule,
        LoadingModule,
        DatetimeSummaryFieldModule,
    ],
    declarations: [
        PaymentRequestReminderSummaryComponent,
    ],
    exports: [
        PaymentRequestReminderSummaryComponent
    ],
})
export class PaymentRequestReminderSummaryModule {
}
